import { Injectable } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';

@Injectable()
export class DataLaerService {
  private window;

  constructor( _windowRef: WindowReferenceService) {

    this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service

  }

  private pingHome(obj: { event: any; pageName?: any; category?: any; action?: any; label?: any; value?: any; user_id?: any; }) {
      if (obj) {  this.window.dataLayer.push(obj); }
  }
  logPageView(url: any) {

      const hit = {
          event: 'content-view',
          pageName: url
      };
      this.pingHome(hit);
  }

  logEvent(event: any, category: any, action: any, label: any) {
      const hit = {
          event: event,
          category: category,
          action: action,
          label: label
      };
       this.pingHome(hit);
  }

  logCustomDimensionTest(value: any) {
      const hit = {
          event: 'custom-dimension',
          value: value
      };
      this.pingHome(hit);
  }

  logCustomid(value: any) {
    const hit = {
        event: 'userid',
        user_id: value
    };
    this.pingHome(hit);
}

  // .. add more custom methods as needed by your app.

}
